module.exports = __webpack_public_path__ + "img/2.78975931.png";